import { IApiMachineTool } from './tool-service.types'
import { IApiUserAccount } from './user-service.types'

export enum IApiAssignmentType {
    Usual = 'usual',
    Bucket = 'bucket',
}

export enum OrderAssignmentStatusCode {
    New = 'new',
    Reserved = 'reserved',
    Work = 'work',
    Completed = 'completed',
    Confirmed = 'confirmed',
    Canceled = 'cancelled',
}

export type OrderAssignmentStatusProps = {
    id: number,
    code: OrderAssignmentStatusCode,
    name: string,
}

export const OrderAssignmentStatusSpec: { [key in OrderAssignmentStatusCode]: Omit<OrderAssignmentStatusProps, 'code'> } = {
    [OrderAssignmentStatusCode.New]: { id: -2, name: 'Новое' },
    [OrderAssignmentStatusCode.Reserved]: { id: -1, name: 'Выдано' },
    [OrderAssignmentStatusCode.Work]: { id: 0, name: 'В работе' },
    [OrderAssignmentStatusCode.Completed]: { id: 1, name: 'На подтверждении' },
    [OrderAssignmentStatusCode.Confirmed]: { id: 2, name: 'Завершено' },
    [OrderAssignmentStatusCode.Canceled]: { id: 80, name: 'Отменено' },
}


export const OrderAssignmentStatusList: OrderAssignmentStatusProps[] = Object.keys(OrderAssignmentStatusSpec).map(code => ({
    ...OrderAssignmentStatusSpec[code as keyof typeof OrderAssignmentStatusSpec],
    code: code as OrderAssignmentStatusCode,
}));
export type IApiBatchOperation = {
    id: number,
    batchStageId: number,
    batchNumber: string,
    interchangeabilityGroup: string,
    isManual: boolean,
    isActive: boolean,
    amountUnfinished: number,
    amountReserved: number,
    amountQC: number,
    amountWIP: number,
    routeCode: string,
}


export type IApiOperation = {
    id: number,
    code: string,
    name: string,
    unitProcessTime?: number,
}

export type IApiComponent = {
    productUnitId: number,
    name: string,
    codeName: string,
    vendorCode: string,
}

export type IApiOrderEntity = {
    id: number,
    orderNumber: string,
    orderDescription: string,
    measureUnit: string,
}
export type IApiAssignment = {
    id: number,
    type: IApiAssignmentType,
    status: OrderAssignmentStatusCode,
    batchOperation: IApiBatchOperation,
    component: IApiComponent,
    operation: IApiOperation,
    orderEntity: IApiOrderEntity,
    amountPlanned: number,
    amountCompleted: number,
    planStartAt: string,
    planEndAt: string,
    master: IApiUserAccount,
    machineTool: IApiMachineTool,
    statusName: string,
    measureUnit: string,
}

export type MaterialWithOperations = {
    orderId: number,
    vendorName: string,
    vendorCode: string,
    productUnitId: number,
    orderEntity: IApiOrderEntity,
    routeCode: string,
    routePointStage: string,
    operations: MaterialOperation[],
}

export type MaterialOperation = {
    operationNumber: string,
    operationName: string,
    batchOperationId: number,
    maxAmountPlanned: number,
    unfinishedAmount: number,
    stageId: number,
    interchangeabilityGroup: string,
    amountUnfinished: number,
    operationId: number,
    unitProcessTime: number,
}